<template>
  <div
    id="variable-table">
    <table-component
      ref="variableTable"
      :data="fetchData"
      :showFilter="true"
      sort-by="id"
      sort-order="asc"
      :show-caption="false"
      class="datatable"
      filter-placeholder=""
      filterNoResults="">
      <table-column
        label=""
        header-class="table-component__minimum__width__column"
        :sortable="false"
        :filterable="false">
        <template slot-scope="row">
          <checkbox
            :id="row.clientReference"
            :checked="checkedVariableIds.indexOf(row.id) > -1"
            v-on:change="(event) => onCheckedChange(row.id, event)"
            check-size="xs"/>
        </template>
      </table-column>
      <table-column
        show="clientReference"
        :label="$t('variables.reference')"
        header-class="table-component__minimum__width__column"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        show="name"
        :label="$t('variables.name')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        :label="$t('variables.unit')"
        show="unit"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        :label="$t('variables.tags')"
        :filterable="false"
        :sortable="false">
        <template
          slot-scope="row">
          <tags
            :value="row.tags" />
        </template>
      </table-column>
    </table-component>
  </div>
</template>

<script>
import TableColumn from '@/components/shared/table/components/TableColumn';
import TableComponent from '@/components/shared/table/components/TableComponent';
import Tags from '@/components/variable/Tags';
import Checkbox from '@/components/shared/forms/Checkbox';

export default {
  name: 'VariableTableSelector',
  components: {
    Checkbox,
    Tags,
    TableColumn,
    TableComponent
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    },
    checkedVariableIds: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      variableIds: [],
      filter: '',
      filterTimer: null
    };
  },
  watch: {
    value: {
      handler: function () {
        this.variableIds = this.value;
      }
    },
    data: {
      handler: function () {
        this.$refs.variableTable.refresh();
      }
    }
  },
  methods: {
    fetchData ({ page, filter, sort }) {
      if (this.filter !== filter) {
        this.filter = filter;
        if (this.filterTimer !== null) clearTimeout(this.filterTimer);
        this.filterTimer = setTimeout(() => {
          this.$emit('onRetrieveVariables', {page: page, filter: filter, sort: sort});
          this.filterTimer = null;
        }, 500);
      } else {
        this.$emit('onRetrieveVariables', {page: page, filter: filter, sort: sort});
      }
      if (typeof this.data === 'object' && this.data !== null && this.data.data && this.data.pagination) {
        const filteredIds = this.data.data.map(variable => variable.id);
        this.variableIds = this.variableIds.filter(id => filteredIds.includes(id));
        this.$emit('input', this.variableIds);
        return this.data;
      }
      this.$emit('input', []);
      return {
        data: [],
        pagination: {}
      };
    },
    onCheckedChange (id, event) {
      this.$emit('checkedChange', id, event);
    },
    size () {
      if (this.data.data) {
        return this.data.data.length;
      }
      return 0;
    }
  }
};
</script>

<style lang="scss">
  @import "../../stylesheets/variables.scss";

  .tags {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/VariableTableSelector.vue